module.exports = __webpack_public_path__ + "media/images/simulation-pic-42f6c3b8.png";